import React from "react";
// import { useTranslation } from "react-i18next";
import HeroVideo1 from "../components/HeroVideo1";
import RichText from "../components/RichText";
import ImageText2 from "../components/Imagetext2";
import ImageText3 from "../components/ImageText3";

import video from "../assets/videos/chiptunningvideo.mp4";
import imageurl1 from "../assets/images/chiptuning1.png";
import imageurl2 from "../assets/images/chiptuning2.png";
import imageurl3 from "../assets/images/chiptuning3.png";
import video2 from "../assets/videos/service2.mp4";
function ChipTuning() {
  // const { t } = useTranslation();

  const text1 = (
    <>
      <h2 className="text-white text-3xl font-bold">
        Devoordelen en nadelen van stage 1
      </h2>
      <br />
      <h3 className="text-white text-2xl font-bold">
        Voordelen van Chiptuning:
      </h3>
      <br />
      <ul className="list-decimal text-left">
        <li>
          <b>Vermogen en koppel.</b> Bij een stage 1 chiptuning wordt het
          motormanagement aangepast door middel van softwarematige aanpassingen.
          Hierbij wordt het vermogen en koppel van het voertuig aangepast binnen
          de grenzen van de motor. 
        </li>
        <li>
          <b>Betere rijervaring. </b>Met meer vermogen reageert de auto sneller
          op het gaspedaal, wat de rijervaring dynamischer en soepeler maakt.
          Een snellere acceleratie en betere prestaties, wat vooral merkbaar is
          bij inhaalmanoeuvres tijdens het rijden op een heuvelachtig terrein. 
        </li>
        <li>
          <b>Efficiënter brandstofverbruik. </b>Hoewel dit afhankelijk is van de
          rijstijl, kan chiptuning het brandstofverbruik verbeteren. De motor
          werkt efficiënter door een geoptimaliseerde afstelling, waardoor je in
          bepaalde situaties minder brandstof verbruikt. Het is soms zelfs
          mogelijk om 10 tot 15% te besparen. 
        </li>
        <li>
          <b>Kostenefficiënt.</b> Doordat er geen mechanische aanpassingen nodig
          zijn bij een stage 1 chiptuning zijn de kosten ook aanzienlijk lager.
          Ook is het de meest betaalbare optie en tevens de meest gekozen optie
          ommeeruit het voertuig te halen. 
        </li>
        <li>
          <b>Geoptimaliseerde fabrieksinstellingen.</b> Auto’s zijn vaak
          ingesteld met conservatieve waarden om in allerlei rijomstandigheden
          betrouwbaar te presteren. Chiptuning optimaliseert deze instellingen
          voor betere prestaties in een specifiek gebied, zoals sneller
          accelereren.
        </li>
      </ul>
      <br />
      <h3 className="text-white text-2xl font-bold">Nadelen Van Chiptuning</h3>
      <br />
      <p className="text-lg text-white text-left">
        De mening en wat betreft de voor- en nadelen van chiptuning zijn nogal
        verdeeld. Op verschillende pagina’s vind je uiteenlopende
        veronderstellingen. Voorbeelden hiervan zijn slijtage en brandstof.
        Beide zijn geheel afhankelijk van het rijgedrag, houdt u hetzelfde
        rijgedrag aan dan zal deze ook hetzelfde blijven als voor chiptuning.
        Bij het aanspreken van extra vermogen zal uw motor wel zwaarder belast
        worden. De meest voorkomende nadelen van chiptuning vindt u hieronder:
      </p>
      <br />
      <ul className="list-decimal text-left">
        <li>
          <b>Software-updates</b> Sommige auto fabrikanten brengen
          software-updates uit voor het motormanagement van de auto’s. Dit
          gebeurt meestal bij het afnemen van een beurt bij de dealer, dit komt
          voornamelijk voor bij de nieuwere auto’s. Bij een software-update kan
          het zijn dat de tuning wordt overschreven waardoor de auto terug moet
          naar de tuner om deze opnieuw te laten tunen. Let op! Sommige
          autofabrikanten zetten na de software-update een lock op de ECU van de
          auto waardoor de tuner er niet meer in kan. Heeft u een tuning van
          X-TREMETUNINGS op uw auto zitten en krijgt u een software-update bij
          uw dealer? Het is bij ons mogelijk om de auto terug in de originele
          staat te zetten voordat u naar de garage gaat. Neem contact met ons op
          om te kijken naar de mogelijkheden voor uw auto!
        </li>
        <li>
          <b>Fabrieksgarantie</b> Het verlies van fabrieksgarantie is iets wat
          veel voorkomt bij chiptuning. Autofabrikanten bieden vaak garanties
          die specifiek van toepassing zijn op ongewijzigde voertuigen. Bij het
          aanpassen van de motor van de auto is het mogelijk dat de fabrikant
          weigert om eventuele schade onder deze garantie te dekken. Dit kan
          ervoor zorgen dat je met onvoorzienbare kosten komt te zitten als er
          zich problemen voordoen met uw auto. Heeft u een tuning van X-TREME
          TUNINGS op uw auto zitten en moet u naar de garage? Het is bij ons
          mogelijk om de auto terug in de originele staat te zetten voordat u
          naar de garage gaat. Neem contact met ons op om te kijken naar de
          mogelijkheden voor uw auto!
        </li>
      </ul>
    </>
  );

  const text2 = (
    <>
      <h2 className="text-white text-3xl font-bold">
        Hoe lang duurt een chiptuning?
      </h2>
      <br />
      <p className="text-white text-lg text-left">
        Het afnemen van een service bij X-TREM TUNINGS duurt ongeveer 1,5 tot 2
        uur. U kunt bij ons onder het genot van koffie en/of thee wachten in de
        wachtruimte. Wilt u meer weten over onze werkwijze, klik dan hier.
      </p>
      <br />
      <h3 className="text-white text-2xl font-bold">
        Wanneer is stage 1 niet mogelijk?
      </h3>
      <br />
      <p className="text-white text-lg text-left">
        Sommige autofabrikanten leveren hun auto’s al met een anti-tune lock in
        het systeem van de auto. Hierdoor is het niet mogelijk om de software
        van de ECU uit te lezen en kunnen wij deze ook niet tunen. Er zijn ook
        auto’s die voorheen al een softwarematige aanpassing hebben laten doen
        bij een andere tuner, het kan voorkomen dat deze tuner een lock op de
        ECU zet. Dit zorgt er ook voor dat wij niet in de software van de auto
        kunnen. Mocht uw auto al eerder een softwarematige aanpassing hebben
        gehad, dan kunt u aan degene die de aanpassingen heeft uitgevoerd
        verzoeken of zij de software vrij willen geven. Let op, als uw auto
        vanuit de dealer is gelockt dan zullen ze deze vaak niet vrijgeven.
        X-TREMETUNINGS zet tijdens het uitvoeren van de service nooit een
        anti-tune lock op de ECU. Er zijn voertuigen waarvan de motoren geen
        turbo hebben. De vermogenswinst na een chiptuning stijgt hier soms maar
        een paar procent, waardoor het niet aantrekkelijk is om deze uit te
        voeren. In enkele gevallen is een chiptuning bij een motor zonder turbo
        nog wel aantrekkelijk. Heeft u een auto zonder turbo en wilt u weten wat
        uw mogelijkheden zijn, neem dan contact met ons op.
      </p>
    </>
  );

  const text3 = (
    <>
      Stage 2 is een aanvulling van de stage 1. Stage 2 chiptuning is een op
      maat gemaakte chiptuning voor uw auto. Hier worden belangrijke parameters
      aangepast en op elkaar afgestemd. Ook gaan wij verder met de ontwikkeling
      van de software van het voertuig. Bij deze dienst wordt een
      motoroptimalisatie uitgevoerd en kijken we naar wat uw voertuig nodig
      heeft. De originele luchtinlaatsystemen zijn ontwikkeld om de lucht te
      zuiveren en het motorgeluid te dempen. Door deze demping beperkt het
      luchtvolume.
      <br />
      Voordat deze dienst wordt afgenomen raden wij u aan om een aantal
      mechanische aanpassingen te doen aan uw voertuig. Deze aanpassingen worden
      uitgevoerd zodat de motor meerlucht kan inademen en uitademen met een
      goede flow. Hoemeer koude lucht er in de motor gaat, des te beter de motor
      zal presteren.
      <br />
      Denodige aanpassingen zijn een betere intake en sport luchtfilter, een
      downpipe met racekatalysator en een grotere intercooler. Hierna wordt de
      software aangepast naar een stage 2 chiptuning software.
    </>
  );

  const text4 = (
    <>
      <p className="text-white text-lg">
        Bij stage 3 chiptuning halen wij het uiterste uit uw voertuig. Stage 3
        chiptuning is net zoals een stage 2 chiptuning een op maat gemaakte
        software. Iedere auto verschilt en daar houdenwij rekening mee. Stage 3
        tuning is een upgrade op stage 2 in zowel mechanische als softwarematige
        aanpassingen. Ook hier worden parameters aangepast voor een uitstekende
        rijervaring.
      </p>
      <p className="text-white text-lg">
        Stage 3 chiptuning vergt de mechanische aanpassingen van stage 2
        chiptuning met een toevoeging van een extra mechanische aanpassing De
        nodige aanpassingen zijn een betere intake en sport luchtfilter, een
        downpipe met racekatalysator, een grotere intercooler en een grotere
        turbo. Hierna wordt de software aangepast naar een stage 3 chiptuning
        software.
      </p>
      <p className="text-white text-lg">
        Deze service is alleen beschikbaar op aanvraag. Heeft u vragen over deze
        service of wilt u weten of uw voertuig hiervoor in aanmerking komt? Neem
        dan contact met ons op.
      </p>
    </>
  );
  return (
    <div>
      <HeroVideo1 videoSource={video} heading="CHIPTUNING" />
      <RichText
        text="De meest voorkomende service die wordt afgenomen in chiptuning is stage 1 chiptuning. Doordat er geen mechanische aanpassingen aan het voertuig nodig zijn, is stage 1 chiptuning daarom de meest gevraagde en de meest afgenomen service van X-TREMETUNINGS"
        bordered={false}
      />
      <ImageText2
        heading="STAGE 1"
        text="Chiptuning stage 1 is een type motorafstelling waarbij de software van het motormanagementsysteem wordt aangepast om de prestaties van een voertuig te verbeteren. Dit gebeurt meestal door het optimaliseren van de brandstofinjectie, ontstekingstiming en turbodruk (bij turbocharged voertuigen). De originele software vanuit de fabriek wordt hier herschreven. Het doel van stage 1 chiptuning is doorgaans om een verhoogd vermogen en koppel te bereiken zonder dat er fysieke veranderingen aan de motor of het voertuig zelf nodig zijn. Dit is vaak een veilige en populaire optie voor autobezitters die extra prestaties willen zonder de betrouwbaarheid van hun voertuig in gevaar te brengen."
        imageUrl={imageurl1}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <RichText text={text1} bordered="true" />
      <RichText text={text2} bordered="true" />
      <ImageText3
        imageUrl={imageurl2}
        heading="STAGE 2"
        text={text3}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <ImageText2
        heading="STAGE 3"
        text={text4}
        imageUrl={imageurl3}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <HeroVideo1
        videoSource={video2}
        heading="Benieuwd welke services er beschikbaar zijn voor uw auto?Kies uw auto voor de beschikbare services of klik hier om contact met ons op te nemen!"
        buttontext="Zoek uw optimalisatie"
        buttonlink="/contact-us"
      />
    </div>
  );
}

export default ChipTuning;
